import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import Factura from "./PagoFacturas";
import { Button, Slide, Snackbar } from "@material-ui/core";
import Http from "../../../Http";
import ACCESS from "../../../ACCESS.js";
// import './Depositos.css';

class Depositos extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `pago-deposito-factura/${this.props.id}/filter`,
        deleteUrl: "pago-deposito-factura/delete",
        deleteField: "tipo_cons",
        modUrl: "/Ventas/Deposito",
      },
      TableOp.Table(
        false,
        [
          // { label: "Pago", id: "id" },
          { label: "Factura", id: "tipo_cons" },
          { label: "Importe", id: "importe" },
          { label: "IVA", id: "importe_iva" },
          { label: "Retencion", id: "importe_retencion" },
          { label: "Fecha", id: "createdAt" },
          { label: "Cliente", id: "cliente_rsocial" },
          { label: "Forma Pago", id: "forma_nombre" },
        ],
        [
          // { id: "edit", icon: "edit" },
          { id: "delete", icon: "delete", access: [ACCESS.COBRANZA_APLICACION_PAGOS.EDITAR_DEPOSITO_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.EDITAR_DEPOSITO_CREDITO] },
        ]
      )
    );
    this.table(0, this.rpp, " ", this.orderBy);
    this.inputFileRef = React.createRef();
  }

  tableUdated = async (rows) => {
    const tableRows = rows;
    if (tableRows.length < 1) {
      this.setState({ total: 0 });
      return;
    }
    let total = tableRows.reduce((prev, current) => {
      let sum = Number(
        Number(parseFloat(prev.importe) + parseFloat(current.importe)).toFixed(
          2
        )
      );
      return { importe: sum };
    });
    this.setState({ total: total.importe });
  };

  uploadFile = () => {
    this.inputFileRef.current.click();
  };

  onFileUpload = async (e) => {
    let form = new FormData();
    form.append("file", e.target.files[0]);
    form.append("id_pago_deposito", this.props.id);
    try {
      let res = await Http.post(`pago-deposito-factura/upload-file`, form);
      if (!res.error) {
        this.setState({ sbOpen: true, sbMsg: 'Guardado Correctamente' });
      } else {
        this.setState({ sbOpen: true, sbMsg: res.errMsg });
      }
      this.inputFileRef.current.value = null;
      this.table(0, this.rpp, " ", this.orderBy);
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { total = 0, sbMsg = "", sbOpen = false } = this.state;
    const { id, linea, id_plazo } = this.props;
    return (
      <div className="row">
        <div className="col-sm-12">
          <Factura
            id_plazo={id_plazo}
            id_pago_deposito={id}
            linea={linea}
            onSave={() => {
              this.table(0, this.rpp, " ", this.orderBy);
            }}
          />
        </div>
        <div
          className="col-12"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div
            style={{
              margin: "0px 20px",
            }}
          >
            <Button
              onClick={this.uploadFile}
              color="primary"
              variant="contained"
            >
              Carga de Facturas
            </Button>
            <input
              type="file"
              hidden={true}
              ref={this.inputFileRef}
              accept=".csv"
              onChange={this.onFileUpload}
            />
          </div>
          <div>
            <b>Total:</b> ${total}
          </div>
        </div>
        <div className="col-sm-12">
          <this.TableRender />
        </div>

        <Snackbar
          open={sbOpen}
          onClose={() => { this.setState({ sbOpen: false }) }}
          TransitionComponent={Slide}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(Depositos);
